import { render, staticRenderFns } from "./giveDaysDialog.vue?vue&type=template&id=d4a0c466&scoped=true&"
import script from "./giveDaysDialog.vue?vue&type=script&lang=js&"
export * from "./giveDaysDialog.vue?vue&type=script&lang=js&"
import style0 from "./giveDaysDialog.vue?vue&type=style&index=0&id=d4a0c466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a0c466",
  null
  
)

export default component.exports